import React, { useState, useEffect } from "react";
import { Image, Row, Col, Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import Axios from "axios";
import { isBrowser } from "react-device-detect";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/orderDetailsItem";

function OrderDetailsItemDeposit(props) {
    const [pricePaid, setPricePaid] = useState(0);
    const [outstandingAmount, setOutStandingAmount] = useState(0);
    const [attention, setAttention] = useState(false);

    const user = useSelector((state) => state.user);

    const modalDefaultValues = {
        open: false
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    useEffect(() => {
        let pricePay = 0;
        console.log(props.item);
        if (props.item.fullyPaid == "true") {
            pricePay = props.item.fullPriceWhenOrdered * props.item.quantity;
        } else {
            pricePay = props.item.depositPriceWhenOrdered * props.item.quantity;
        }

        const fullPrice = props.item.fullPriceWhenOrdered * props.item.quantity;
        setPricePaid(pricePay);
        setOutStandingAmount(fullPrice - pricePay);

        CheckAttention(props.item);
    }, []);

    function handleAddDepositProductToCart() {
        console.log("userID: ", user.id);
        console.log("product code: ", props.item.productCode);
        console.log("quantity: ", props.item.quantity);
        console.log("price status: ", "dpr");
        console.log("custom Item: ", props.item.customItem.toString());
        console.log("custom Data: ", JSON.stringify(props.item.itemDetails.customItems));
        console.log("linkedToOrderItemUUID:	", props.item.uuid);
    }

    function CheckAttention(item) {
        if (item.depositRequested == "true") {
            console.log("deposit");
            setAttention(true);
        }
        if (item.unReadMessages) {
            setAttention(true);
        }
    }

    function handleOpenSecondOrderConfirmation() {
        const data = { orderID: props.item.repaidOrderUUID };

        Axios.post("/pods/3dPrintingShop/orders/produceOrderConfirmationPDF", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal((prevState) => {
                        return { ...prevState, open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function pdfLoaded(filename) {
        const data = { filename: filename };

        Axios.post("/pods/onlinePayments/deleteTempPDF", data)
            .then((res) => {
                const data = res.data;
            })
            .catch((err) => console.log(err));
    }

    const browserDisplay = (
        <div>
            <div style={OrderDetailsItemStyles.bodyWithoutPointer}>
                <Row>
                    <Col md="auto">
                        <Image
                            src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                            style={OrderDetailsItemStyles.image}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <strong>Name:</strong> {props.item.itemDetails.title} <br />
                                <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                                {props.item.customItem == "true" && (
                                    <div>
                                        <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>
                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "text" || field.type == "dColour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                        {props.item.itemDetails.customColours && (
                                            <div>
                                                <br />
                                                <strong>Colours:</strong>
                                                {props.item.itemDetails.customItems.map((field, index) => {
                                                    if (field.type == "colour") {
                                                        return (
                                                            <div key={index}>
                                                                {field.fieldName}: {field.fieldValue}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>
                            <Col style={OrderDetailsItemStyles.middleColumn}>
                                {attention && (
                                    <div>
                                        <strong>Attention Needed </strong> - Please click this item or go to Printing Progress at the top
                                    </div>
                                )}
                            </Col>
                            <Col style={OrderDetailsItemStyles.columnRight}>
                                <strong>Deposit Item</strong> <br />
                                <strong>Full Price Per Item:</strong> £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />
                                <strong>Deposit Price Per Item:</strong> £{(props.item.depositPriceWhenOrdered / 100).toFixed(2)} <br /> <br />
                                <strong>Price Paid: </strong> £{(pricePaid / 100).toFixed(2)} <br />
                                <span style={OrderDetailsItemStyles.redText}>
                                    <strong>To Pay:</strong> £{(outstandingAmount / 100).toFixed(2)}
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div>
                <Row>
                    <Col></Col>
                </Row>
            </div>
            {props.item.fullyPaid == "true" && (
                <div style={OrderDetailsItemStyles.bottomBox}>
                    The full amount of this item has been paid in another order{" "}
                    <Button onClick={handleOpenSecondOrderConfirmation}>View Confirmation</Button>
                </div>
            )}
        </div>
    );

    const mobileDisplay = (
        <div style={OrderDetailsItemStyles.mobile_itemBody}>
            <div style={OrderDetailsItemStyles.flexRow}>
                <div style={OrderDetailsItemStyles.mobile_imageContainer}>
                    <Image
                        src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                        style={OrderDetailsItemStyles.image}
                    />
                </div>
                <div style={OrderDetailsItemStyles.mobile_infoContainer}>
                    <div style={OrderDetailsItemStyles.mobile_orderRefs}>
                        <strong>Name:</strong> {props.item.itemDetails.title} <br />
                        <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                        {props.item.customItem == "true" && (
                            <div>
                                <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>
                                {props.item.itemDetails.customItems.map((field, index) => {
                                    if (field.type == "text" || field.type == "dColour") {
                                        return (
                                            <div key={index}>
                                                {field.fieldName}: {field.fieldValue}
                                            </div>
                                        );
                                    }
                                })}
                                {props.item.itemDetails.customColours && (
                                    <div>
                                        <br />
                                        <strong>Colours:</strong>
                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "colour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                        <strong>Deposit Item</strong> <br /> <br />
                    </div>
                </div>
            </div>
            <div style={OrderDetailsItemStyles.flexRow}>
                <div style={OrderDetailsItemStyles.moobile_itemTotalsHeadings}>
                    <strong>Full Price Per Item:</strong> <br />
                    <strong>Deposit Price Per Item:</strong> <br /> <br />
                    <strong>Price Paid: </strong> <br />
                    <span style={OrderDetailsItemStyles.redText}>
                        <strong>To Pay:</strong>
                    </span>
                </div>
                <div style={OrderDetailsItemStyles.mobile_itemTotals}>
                    £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />£{(props.item.depositPriceWhenOrdered / 100).toFixed(2)} <br /> <br />
                    <div style={OrderDetailsItemStyles.redText}>
                        £{(pricePaid / 100).toFixed(2)} <br />£{(outstandingAmount / 100).toFixed(2)}
                    </div>
                </div>
            </div>
            {attention && (
                <div style={OrderDetailsItemStyles.redText}>
                    <strong>Attention Needed </strong> - Please click this item or go to Printing Progress at the top
                </div>
            )}
        </div>
    );

    return (
        <div>
            {isBrowser ? browserDisplay : mobileDisplay}
            <br />
            <Modal size="lg" show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        id="iframepdf"
                        width="100%"
                        height="500"
                        src={`${window.location.origin}/content/temp/test.pdf`}
                        onLoad={pdfLoaded.bind(this, "test.pdf")}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default OrderDetailsItemDeposit;
